/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleResponse extends models.RecommendationExclusionRule {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleResponse>): RecommendationExclusionRuleResponse {
        let obj = Object.assign(new RecommendationExclusionRuleResponse(), model);
        RecommendationExclusionRuleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleResponse>): RecommendationExclusionRuleResponse {
        if (!model) return null;
        return RecommendationExclusionRuleResponse.newInstance(<RecommendationExclusionRuleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleResponse) {
        if (!obj) return;

        models.RecommendationExclusionRuleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleResponse): boolean {
        if (models.RecommendationExclusionRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationExclusionRuleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
